import { Chip, IconButton } from "@mui/material";
import { Stack } from "@mui/system";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import {
  colors,
  spacing,
  typography,
} from "../../../../../../../../../assets/styles/tokens";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import saveAs from "file-saver";
import { additionalQueriestableHeadings06 } from "../../../../../../BusinessLeaderDashboard/AdditionalQueries/AdditionalQueriesAccordion/AdditionalQueriesConstants";
import { useMemo } from "react";

const ConversionsFilter = () => {
  const { conversionLastTwoWeeksQueryData } = useSelector(
    (state: any) => state.businessLeaderDashBoard,
  );
  const lastTwoWeeksLabel = useMemo(() => {
    if (!conversionLastTwoWeeksQueryData?.query_output?.length)
      return "Last 14 days";

    const dates = conversionLastTwoWeeksQueryData.query_output
      .map((row: any) => row?.brand_action_date)
      .filter(Boolean)
      .sort();
    const oldest = dayjs(dates[0]);
    const newest = dayjs(dates[dates.length - 1]);

    return `Last 14 days, ${oldest.format("DD/MM/YYYY")} - ${newest.format("DD/MM/YYYY")}`;
  }, [conversionLastTwoWeeksQueryData?.query_output]);

  const headCells = Object.entries(additionalQueriestableHeadings06);

  const handleExportCSV = () => {
    const csvRows = [];

    // Extract the table headers
    const headers = headCells.map((pair: any) => pair[0]) as any;
    csvRows.push(headers.join(","));

    // Extract the table data
    // eslint-disable-next-line
    conversionLastTwoWeeksQueryData?.query_output?.map((row: any) => {
      let rowData = [] as any;
      rowData.push(dayjs(row?.brand_action_date).format("DD-MM-YYYY"));
      rowData.push(Math.round(row?.Total_ftd));
      rowData.push(Math.round(row?.FTD_loaded));
      rowData.push(Math.round(row?.perc_loaded_from_total * 100) + "%");
      rowData.push(Math.round(row?.Total_Qftd));
      rowData.push(Math.round(row?.QFTD_loaded));
      rowData.push(Math.round(row?.Qftd_perc_loaded_from_total * 100) + "%");
      csvRows.push(rowData.join(","));
    });

    // Convert CSV rows to a single string
    const csvString = csvRows.join("\n");

    // Create a blob and download the file
    const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
    saveAs(blob, "ConversionLoadingPercentage.csv");
  };

  return (
    <>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
         sx={{
          mt:spacing.Spacing.xs.$value,
          mb:spacing.Spacing.sm.$value,
        }}
      >
        <Chip
          sx={{
            fontSize: typography.Size.Text.sm.$value,
            fontWeight: typography.Font_weight.Semibold.$value,
            borderRadius: spacing.Radius.md.$value,
            backgroundColor: colors.GrayLightMode[50].$value,
            border: "1px solid " + colors.GrayLightMode[300].$value,
            color: colors.GrayLightMode[500].$value,
          }}
          label={lastTwoWeeksLabel}
        />
        <IconButton
          color="secondary"
          size="large"
          onClick={handleExportCSV}
          data-tracker="669"
        >
          <FileDownloadIcon sx={{ color: colors.GrayLightMode[700].$value }} />
        </IconButton>
      </Stack>
    </>
  );
};

export default ConversionsFilter;
